<template>
  <div
    class="p-5 box-border h-full overflow-y-scroll"
    :class="{
      'custom-scrollbar': isLightMode(),
      'custom-scrollbar-dark': !isLightMode()
    }"
  >
    <JudgeDetailResult :judgeLoading="isJudgeLoading" />
    <div
      v-if="!isJudgeLoading && judgeDetail && (judgeDetail.compileError || judgeDetail.runtimeError)"
      class="border shadow-lg border-red-600 bg-red-100 dark:bg-red-900 dark:border-red-900 rounded mb-6 p-4 text-red-600 dark:text-dark-text"
      style="border-radius: 1rem"
    >
      {{ judgeDetail ? judgeDetail.compileError : '' }}
      {{ judgeDetail ? judgeDetail.runtimeError : '' }}
    </div>
    <JudgeDetailTestCase />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import JudgeDetailResult from './children/JudgeDetailResult.vue'
import JudgeDetailTestCase from './children/JudgeDetailTestCase.vue'

import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useJudgeDetailPresenter } from '@/presentation/composables/judge/useJudgeDetailPresenter'
import { useJudgeStatePresenter } from '@/presentation/composables/judge/useJudgeStatePresenter'

export default defineComponent({
  components: {
    JudgeDetailResult,
    JudgeDetailTestCase
  },
  setup(props) {
    const { judgeDetail } = useJudgeDetailPresenter()
    const { isJudgeLoading } = useJudgeStatePresenter()
    const { isLightMode } = useConfigStatePresenter()

    return {
      judgeDetail,
      isJudgeLoading,
      isLightMode
    }
  }
})
</script>
